export const customerDetail = {
  loadingError: 'Could not load customer',
};
